// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox_checkbox__3Dg_b","selected":"checkbox_selected__2iHV6","naked":"checkbox_naked__3lKpd","loader":"checkbox_loader__1hg1S"};